import Vue from "vue";

import ConfirmDeleteAccount from "./ConfirmDeleteAccount.vue";

export function load() {
    const selector = "confirm-delete-account";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(ConfirmDeleteAccount, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
